import { useState } from "react";
import { TrackingPartner } from "src/api/partner-management.api";
import { BolLocationOptions } from "../data/options.ts";
import { Card } from "src/components/card.tsx";

export function EditForm({
    formData,
    handleSubmit,
    handleCancel,
    saving,
}: {
    formData: TrackingPartner;
    handleSubmit: (formData: TrackingPartner) => void;
    handleCancel: () => void;
    saving: boolean;
}) {
    const [requestor, setRequestor] = useState<string>(
        formData.Requestor ?? "",
    );
    const [bolType, setBolType] = useState<string>(formData.BOLType ?? "");
    const [referenceKey, setReferenceKey] = useState<string>(
        formData.ReferenceKey ?? "",
    );
    const [active, setActive] = useState<boolean>(formData.Active);

    return (
        <Card customization={"w-xl bg-gray-50 border-gray-200"}>
            <div className="flex flex-col gap-4 h-full w-full p-6 justify-center items-center">
                <h2 className="text-xl font-bold text-gray-700 mb-2">
                    {formData.Id != null ? "Edit Partner" : "Add Partner"}
                </h2>

                <form
                    className={"flex flex-col justify-between max-w-xs"}
                    onSubmit={(e) => {
                        e.preventDefault();
                        formData.Requestor = requestor;
                        formData.BOLType = bolType;
                        formData.ReferenceKey = referenceKey;
                        formData.Active = active;
                        handleSubmit(formData);
                    }}
                >
                    {formData.Id != null ? (
                        <div
                            className="flex justify-end w-full tooltip tooltip-right"
                            data-tip={active ? "Active" : "Inactive"}
                        >
                            <input
                                hidden={formData.Id == null}
                                className="toggle toggle-primary bg-white"
                                type="checkbox"
                                checked={active}
                                onChange={(e) => {
                                    setActive(e.target.checked);
                                }}
                            ></input>
                        </div>
                    ) : (
                        ""
                    )}

                    <div className="flex justify-left items-center gap-4">
                        <fieldset className="fieldset mb-0 w-full">
                            <legend className="fieldset-legend text-xs font-medium text-gray-600">
                                Partner
                            </legend>
                            <div className="relative text-lg font-semibold">
                                {formData.Partner == "ALL"
                                    ? "UNSELECTED"
                                    : formData.Partner}
                            </div>
                        </fieldset>

                        <fieldset className="fieldset mb-0 w-full">
                            <legend className="fieldset-legend text-xs font-medium text-gray-600">
                                Customer Code
                            </legend>
                            <div className="relative text-lg font-semibold">
                                {formData.CustomerCode}
                            </div>
                        </fieldset>
                    </div>

                    <div className="fieldset">
                        <label className="label">Requestor</label>
                        <input
                            className="input input-bordered input-sm w-full"
                            type="text"
                            value={requestor}
                            required={formData.Partner == "MACROPOINT"}
                            onChange={(e) => setRequestor(e.target.value)}
                        />
                    </div>

                    <div className="flex gap-2">
                        <div className="fieldset mb-0 w-full">
                            <label className="fieldset-legend text-xs font-medium text-gray-600">
                                BOL Location
                            </label>
                            <select
                                className="select select-sm w-full"
                                value={bolType}
                                onChange={(e) => setBolType(e.target.value)}
                            >
                                <option disabled>Select</option>
                                {Object.entries(BolLocationOptions).map(
                                    ([key, value]) => (
                                        <option key={key} value={value}>
                                            {key.replace("_", " ")}
                                        </option>
                                    ),
                                )}
                            </select>
                        </div>

                        <div className="fieldset mb-0 w-full">
                            <label className="fieldset-legend text-xs font-medium text-gray-600">
                                Reference Key
                            </label>
                            <div
                                className="tooltip tooltip-right"
                                data-tip={
                                    bolType != "" ? "N/A" : "Stop reference key"
                                }
                            >
                                <input
                                    className="input input-bordered input-sm w-full pl-3 pr-8"
                                    type="text"
                                    data-tip="N/A"
                                    value={referenceKey}
                                    required={bolType == ""}
                                    disabled={bolType != ""}
                                    maxLength={2}
                                    onChange={(e) =>
                                        setReferenceKey(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-end items-center gap-4 mt-2">
                        <button
                            className="btn-link btn-sm"
                            type="reset"
                            onClick={handleCancel}
                            disabled={saving}
                        >
                            cancel
                        </button>
                        <button
                            className="btn btn-sm btn-primary w-15"
                            type="submit"
                            disabled={saving}
                        >
                            {saving ? (
                                <span className="loading loading-spinner loading-sm"></span>
                            ) : (
                                "save"
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </Card>
    );
}
